import { useState } from 'react';
import { Checkbox } from 'synfrastructure';
import { SingleDatePicker } from 'react-dates-gte-react-17';
import { ICON_AFTER_POSITION } from 'react-dates-gte-react-17/constants';
import PropTypes from 'prop-types';
import moment from 'moment';
import translateErrors from '../translateErrors';
import InputScaffold from '../../forms/InputScaffold';
import ToggleScaffold from '../../forms/ToggleScaffold';
import Icon from '../../icons/Icon';

const Date = ({ event, field, autoFocus, onFieldRemove, onChange }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div className="input-group input-group--large">
      <div className="custom-request-form__field--title">
        <h3>Date Field</h3>
        <button
          className="button button--plain button--icon"
          onClick={onFieldRemove}
          type="button"
        >
          <Icon icon="Trash" />
          <span>Remove</span>
        </button>
      </div>

      <InputScaffold
        label="Label"
        required
        validation={translateErrors(field.get('error')?.label)}
      >
        <input
          type="text"
          name="label"
          value={field.get('label') || ''}
          onChange={e => onChange(field.set('label', e.target.value))}
          autoFocus={autoFocus}
        />
      </InputScaffold>

      <InputScaffold
        label="Default Value"
        validation={translateErrors(field.get('error')?.value)}
      >
        <SingleDatePicker
          date={field.get('value') ? moment.utc(field.get('value')) : null}
          onDateChange={date => onChange(field.set('value', date))}
          focused={focused}
          onFocusChange={({ focused }) => setFocused(focused)}
          noBorder
          withPortal
          showClearDate
          customInputIcon={<Icon icon="Calendar" />}
          inputIconPosition={ICON_AFTER_POSITION}
          displayFormat="MM/DD/YYYY"
          numberOfMonths={1}
          transitionDuration={0}
          initialVisibleMonth={() =>
            field.get('value')
              ? moment.utc(field.get('value'))
              : moment.utc(event.get('start_date'))
          }
        />
      </InputScaffold>

      <InputScaffold
        label="Description"
        validation={translateErrors(field.get('error')?.description)}
      >
        <textarea
          name="description"
          value={field.get('description') || ''}
          onChange={e => onChange(field.set('description', e.target.value))}
        />
      </InputScaffold>

      <ToggleScaffold
        label="Required"
        validation={translateErrors(field.get('error')?.required)}
      >
        <Checkbox
          id="required"
          name="required"
          checked={!!field.get('required')}
          onChange={e => onChange(field.set('required', e.target.checked))}
        />
      </ToggleScaffold>
    </div>
  );
};

Date.propTypes = {
  event: PropTypes.object,
  field: PropTypes.object,
  onFieldRemove: PropTypes.func,
  onChange: PropTypes.func,
};

export default Date;
